// @flow

import { createContext, useContext } from 'react';
import { type Tenant, CROSS_BORDER, getTenantFromCode } from '@tectonics/commons/tenant';

export type ControllerContextType = {
  hash: string,
  lookAndFeelCode?: string,
  localTenancy?: string,
};

const ControllerContext = createContext<ControllerContextType>({});

export const ControllerContextProvider = ControllerContext.Provider;

export function useControllerContext(): ControllerContextType {
  return useContext(ControllerContext);
}

export function useLocalTenancyAsTenant(): Tenant {
  const { localTenancy } = useControllerContext();
  return getTenantFromCode(localTenancy || CROSS_BORDER.code);
}
